module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "page-header"
  }, [_c('div', [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Scheduled Runs")]), _vm._v(" "), _c('p', {
    staticClass: "page-subtitle"
  }, [_vm._v("Total: " + _vm._s(_vm.totalElements) + " runs")])]), _vm._v(" "), _c('div', {
    staticClass: "search-controls"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Search Run")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.query),
      expression: "filters.query"
    }],
    staticClass: "control-input",
    attrs: {
      "type": "text",
      "placeholder": "Run name or ID..."
    },
    domProps: {
      "value": (_vm.filters.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.performSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "query", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Trainer")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.trainerId),
      expression: "filters.trainerId"
    }],
    staticClass: "control-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "trainerId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.performSearch]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Trainers")]), _vm._v(" "), _vm._l((_vm.allTrainers), function(t) {
    return _c('option', {
      key: t.id,
      domProps: {
        "value": t.id
      }
    }, [_vm._v("\n                " + _vm._s(t.firstName) + " " + _vm._s(t.lastName) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "control-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.date),
      expression: "filters.date"
    }],
    staticClass: "control-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.date)
    },
    on: {
      "change": _vm.performSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control-group",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-end"
    }
  }, [_c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "height": "34px"
    },
    on: {
      "click": _vm.performSearch
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('race-table-list', {
    attrs: {
      "races": _vm.racesScheduled,
      "message-empty-list": "There are no scheduled runs",
      "type": "resume"
    }
  }), _vm._v(" "), (_vm.totalElements > 0) ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('paginate', {
    attrs: {
      "page-count": Math.ceil(_vm.totalElements / _vm.filters.pageSize),
      "page-range": 7,
      "margin-pages": 2,
      "click-handler": _vm.changePageHandler,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'pagination custom-pagination',
      "page-class": 'page-item'
    },
    model: {
      value: (_vm.filters.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pageNo", $$v)
      },
      expression: "filters.pageNo"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9c92748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/ScheduledRuns.vue
// module id = 1713
// module chunks = 2